module.exports = __webpack_public_path__ + "img/logo.7d2fbeaa.png";